'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidDocument = function IoAndroidDocument(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm22.5 3.8l10 10v19.3c0 1.7-1.4 3.2-3.1 3.2h-18.8c-1.7 0-3.1-1.5-3.1-3.2v-26.2c0-1.7 1.4-3.1 3.1-3.1h11.9z m-1.2 11.2h8.7l-8.7-8.7v8.7z' })
        )
    );
};

exports.default = IoAndroidDocument;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-document.js
// module id = 2087
// module chunks = 0